'use client';

import { useTranslations } from 'next-intl';
import styles from './TripPriceSkeleton.module.css';

export const TripPriceSkeleton = () => {
  const t = useTranslations('journey');

  return <output className={styles.skeleton} aria-label={t('overview_loading_price')} />;
};
